module.exports = __webpack_public_path__ + "img/mentalIntro2.4765f923.png";